/**
 * PageTitleController
 * Updates the browser tab title based on the current route
 *
 * Mount this component once at the app root level, inside BrowserRouter.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setPageTitle } from '@/lib/pageTitle';

export function PageTitleController() {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location.pathname]);

  return null;
}
